module.exports = __webpack_public_path__ + "static/media/b2.db0a0390.jpg";